'use client';

import { RemindMeButton } from '@/app/components/remind-me-button';
import { REMINDER_MODULES } from '@/tracking/amplitude/events/general/reminder';
import { useShowRemindMe } from '@/hooks/use-show-remind-me';

type EpicHubRemindMeProps = {
    zoneUid: string;
    gameId: string;
    gameName: string;
};

export const EpicHubRemindMe = ({ zoneUid, gameId, gameName }: EpicHubRemindMeProps) => {
    const showRemindMe = useShowRemindMe();

    if (!showRemindMe) {
        return null;
    }

    return (
        <div className="epic-hub-header__remind-me">
            <RemindMeButton
                zoneUid={zoneUid}
                gameId={gameId}
                module={REMINDER_MODULES.PRE_LAUNCH}
                gameName={gameName}
            />
        </div>
    );
};
